<template>
  <div class="bg-light-gray mb-2">
    <validation-observer ref="formModalObserver" novalidate tag="form">
      <div class="row">
        <div class="col-12 mb-3">
          <icon-view
            :has-border="false"
            icon="fas fa-ban text-danger"
            icon-size="17px"
            title="Decomizar"
            variant="custom-icon-view"
            icon-background="white"
          />
        </div>
        <div class="col-12 col-lg-4 col-md-12 col-sm-6 col-xs-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-drop-down
              :options="reasons"
              label="Razón:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              class="w-100 mb-4 bold-label"
              custom-error-msg="Favor seleccione una razón"
              :error="errors[0]"
              v-model="model.reason"
              disabled
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <validation-provider
            v-slot="{ errors }"
            mode="eager"
            rules="required"
          >
            <custom-text-area
              id="txtComment"
              :maxlength="3000"
              placeholder="Escribe un comentario"
              label="Comentario de Justificación:"
              v-model="model.comment"
              :error="errors[0]"
              :custom-error-msg="'Este campo es requerido'"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <div class="bg-white px-4 py-4 mt-3 rounded">
            <div class="mb-3 font-weight-bold">
              <i class="fas fa-plus-circle text-orange mr-2"></i>
              Seleccione Accesorios a Decomisar con el Equipo
            </div>
            <div v-for="(item, index) in accessories" :key="index">
              <custom-callout class="mb-3 custom-callout" :has-toggle="false">
                <div class="row p-3">
                  <div class="col-12 col-lg-3 border-r">
                    <div class="bold font-16">{{ item.name }}</div>
                    <div class="color-secondary-6 font-14">
                      {{ item.model }}
                    </div>
                  </div>
                  <div class="col-12 col-lg-7">
                    <div class="color-secondary-6 font-14">
                      Estatus:
                    </div>
                    <div class="bold">
                      <span class="d-flex align-items-center">
                        <div
                          class="status-indicator"
                          :style="{
                            backgroundColor: '#DDB3D7',
                          }"
                        >
                          &nbsp;
                        </div>
                        <span class="text font-weight-bold">
                          Asignado
                        </span>
                      </span>
                    </div>
                  </div>
                  <div class="col-sm text-right">
                    <action-button
                      id="modal-btn-anadir"
                      :variant="
                        !item.isSelected
                          ? 'outline-success ' + (isMobile ? 'w-100 mt-4' : '')
                          : 'success ' + (isMobile ? 'w-100  mt-4' : '')
                      "
                      type="button"
                      i="fas fa-check"
                      data-target="#modal-cambiar"
                      @click="onSelectAccessory(index)"
                    >
                      {{ item.isSelected ? 'Seleccionado' : 'Seleccionar' }}
                    </action-button>
                  </div>
                </div>
              </custom-callout>
            </div>
            <custom-result-not-found
              v-if="accessories.length == 0"
              text="No hay Información Disponible."
            />
          </div>
        </div>
        <div class="col-12">
          <div class="bg-white px-4 py-4 mt-3 rounded">
            <div class="mb-3 font-weight-bold">
              <i class="fas fa-file text-orange mr-2"></i>
              Documentos
            </div>
            <div v-for="(doc, dKey) in documents" :key="dKey">
              <custom-callout class="mb-3 custom-callout" :has-toggle="false">
                <div class="row py-3 m-0">
                  <div class="col-md-3 col-12 col-spacing student-spacing">
                    <div
                      class="color-secondary-6 font-14 font-weight-normal mr-2"
                    >
                      Documento:
                    </div>
                    <div class="color-black font-16 font-weight-normal">
                      {{ doc.filename }}
                    </div>
                  </div>
                  <div
                    class="col-md col-12 col-spacing student-spacing justify-content-end d-flex"
                  >
                    <action-button
                      class="btn-action-size ml-2 mt-3"
                      i="fas fa-file-download"
                      variant="success"
                      @click="() => handlerDownloadDocument(doc.documentId)"
                    />
                  </div>
                </div>
              </custom-callout>
            </div>
            <custom-callout class="mb-3 custom-callout" :has-toggle="false">
              <div class="row py-3 m-0">
                <div class="col-md-3 col-12 col-spacing student-spacing">
                  <div
                    class="color-secondary-6 font-14 font-weight-normal mr-2"
                  >
                    Documento:
                  </div>
                  <div class="color-black font-16 font-weight-normal">
                    Informe de Uso / Inventario de Equipo
                  </div>
                </div>
                <div
                  class="col-md col-12 col-spacing student-spacing justify-content-end d-flex"
                >
                  <action-button
                    class="btn-action-size ml-2 mt-3"
                    i="fas fa-file-download"
                    variant="success"
                    @click="() => handlerGetReport()"
                  />
                </div>
              </div>
            </custom-callout>
          </div>
        </div>
      </div>
    </validation-observer>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <action-button
        id="btnCancel"
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 px-3"
        @click="$emit('close')"
      />
      <action-button
        id="btnSave"
        i="fas fa-save"
        text="Guardar"
        variant="success px-3"
        @click="handlerSave"
      />
    </div>
  </div>
</template>
<script>
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import IconView from 'icon-view';
import CustomTextArea from '@quisit/custom-text-area';
import CustomCallout from 'custom-callout';
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters } from 'vuex';

import reasonTypes from '@/utils/constants/reasonTypes';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import documentsService from '@/services/api/document.api';

const DEFAULT_REASON_ID = 34;

export default {
  name: 'ConfiscateEquipment',
  components: {
    ActionButton,
    CustomDropDown,
    IconView,
    CustomTextArea,
    CustomCallout,
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      reasons: [],
      documents: [],
      accessories: [],
      unselectedAccessories: [],
      model: {
        comment: '',
        reason: {
          id: DEFAULT_REASON_ID,
          selected: false,
          disabled: false,
          isDirty: false,
          name: 'Acuerdo Interagencial',
          sortOrder: 0,
        },
      },
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
  },
  async mounted() {
    Promise.all([
      this.getAccessories(),
      this.getReasons(),
      this.getDocuments(),
    ]);
  },
  methods: {
    async handlerSave() {
      const isvalid = await this.$refs.formModalObserver.validate();
      if (!isvalid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );
        return;
      }

      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea guardar la información documentada?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) {
        return;
      }

      const payload = {
        ...this.model,
        equipmentId: this.item.id,
        reasonId: this.model.reason.id,
        unselectedAccessories: this.unselectedAccessories,
      };

      this.$emit('save', payload);
    },
    async getReasons() {
      const { data } = await referralAndEquipmentsservice.getReasonsByType(
        reasonTypes.Facilitate
      );
      this.reasons = data;
    },
    async getAccessories() {
      const {
        data,
      } = await inventoryCatalogService.getAssignedAccessoriesByEquipment(
        this.item.id
      );
      this.accessories = data.map((x) => ({
        ...x,
        accepted: true,
        isSelected: true,
      }));
    },
    async getDocuments(index) {
      const { data } = await inventoryCatalogService.getDocumentsToConfiscate(
        this.item.id
      );
      this.documents = data;
    },
    async handlerDownloadDocument(documentId) {
      await documentsService.downloadFromServer(documentId);
    },
    async handlerGetReport() {
      try {
        const { data } = await inventoryCatalogService.getEquipmentReport(
          this.item.id
        );
        await documentsService.downloadFile(data);
      } catch (error) {
        this.ShowToast('Error', 'No se pudo descargar el archivo', 'error');
      }
    },
    onSelectAccessory(index) {
      const item = this.accessories[index];
      item.isSelected = !item.isSelected;
      if (!item.isSelected) {
        this.unselectedAccessories.push(item.id);
      } else {
        const i = this.unselectedAccessories.findIndex((x) => x === item.id);
        if (i >= 0) this.unselectedAccessories.splice(i, 1);
      }
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss"></style>
